<div class="dialog-header">
  <h2 mat-dialog-title>Attention</h2>
  <mat-icon class="dialog-icon" fontIcon="report"></mat-icon>
</div>
<mat-dialog-content>
    <div class="dialog-content">
      <div>You are about to be redirected to a TEST payment page.</div>

      <div><strong>DO NOT enter your personal card details.</strong></div>

      <div>
        <span>Use the following test card details instead:</span>
        <ul>
            <li><div class="li-content">Cardholder Name: <strong>Any name</strong></div></li>
            <li><div class="li-content" (click)="copyPanToClipboard()" >Card: <strong>4111 1111 111 1111</strong> <mat-icon class="copy-icon" fontIcon="content_copy" ></mat-icon></div></li>
            <li><div class="li-content" (click)="copyExpiryToClipboard()">Expiry Date: <strong>03/30</strong> <mat-icon class="copy-icon" fontIcon="content_copy" ></mat-icon></div></li>
            <li><div class="li-content" (click)="copyCvvToClipboard()">CVV: <strong>737</strong> <mat-icon class="copy-icon" fontIcon="content_copy" ></mat-icon></div></li>
        </ul>
      </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions  align="center">
  <button class="ok-btn" color="custom-color" mat-raised-button mat-dialog-close cdkFocusInitial>{{this.btnLabel}}</button>
</mat-dialog-actions>
